<p-fluid>
    <div class="grid flex mb-5">
        <div class="col-7">
            <h1 class="mt-0 mb-0">Containers</h1>
        </div>
        <div class="col-2 flex align-items-center">
            <p-select
                class="p-fluid"
                placeholder="Select a manufacturer"
                [showClear]="true"
                [options]="(manufacturers$ | async)?.getManufacturers()"
                [(ngModel)]="selectedManufacturer"
                optionLabel="name"
                (onChange)="manufacturerChanged()"
                (onClear)="manufacturerCleared()"
            ></p-select>
        </div>
        <div class="col-3 flex align-items-center">
            <input #searchInput pInputText type="text" [(ngModel)]="search" placeholder="Search by Container ID or MBL">
        </div>
    </div>
</p-fluid>

<div class="grid">
    <div class="col-12">
        <p-table #dt
                 [lazy]="true"
                 (onLazyLoad)="tableUpdated($event)"
                 [value]="containers"
                 dataKey="id"
                 [rows]="itemsPerPage"
                 [loading]="loading"
                 [rowHover]="true"
                 styleClass="p-datatable-striped"
                 [paginator]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Containers"
                 [showCurrentPageReport]="true"
                 [totalRecords]="totalNbContainers"
                 responsiveLayout="scroll"
                 [rowsPerPageOptions]="[10,20,25,50,75,100]"
                 sortMode="single"
                 editMode="row"
        >
            <ng-template #caption>
                <p-multiSelect
                    display="chip"
                    [options]="cols"
                    [(ngModel)]="selectedColumns"
                    optionLabel="header"
                    selectedItemsLabel="{0} columns selected"
                    [style]="{ 'min-width': '200px' }"
                    placeholder="Choose Columns"
                    (onChange)="saveSelectedColumns()"
                />
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    @for (column of selectedColumns; track column.field) {
                        <th pSortableColumn="{{ column.field }}">
                            {{ column.header }}
                            <p-sortIcon field="{{ column.field }}"></p-sortIcon>
                        </th>
                    }

                    @if (selectedColumns.length > 0) {
                        <th></th>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-container let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="container">

                    @for (column of selectedColumns; track column.field) {
                        <td>
                            @if (column.editable) {
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input
                                            pInputText
                                            type="text"
                                            [(ngModel)]="container[column.field]" />
                                    </ng-template>

                                    <ng-template pTemplate="output">
                                        {{ container[column.field] }}
                                    </ng-template>
                                </p-cellEditor>
                            } @else if (column.type === 'forecast') {
                                {{ container.forecast.year }}-{{ container.forecast.month | number: '2.0-0' }}
                            } @else if (column.type === 'date') {
                                <span *ngIf="container.lastPushToShippeo">
                                    {{ container.lastPushToShippeo | date: 'd. MMM, y' }}
                                </span>
                            } @else {
                                {{ container[column.field] }}
                            }
                        </td>
                    }

                    @if (selectedColumns.length > 0) {
                        <td>
                            <div class="flex items-center justify-center gap-2">
                                <button
                                    *ngIf="!editing"
                                    pButton
                                    pRipple
                                    type="button"
                                    pInitEditableRow
                                    (click)="onRowEditInit(container)"
                                    text
                                    rounded
                                    severity="secondary"
                                >
                                    <icon icon="edit" />
                                </button>
                                <button
                                    *ngIf="editing"
                                    pButton
                                    pRipple
                                    type="button"
                                    pSaveEditableRow
                                    pButtonIcon="pi pi-check"
                                    (click)="onRowEditSave(container)"
                                    text
                                    rounded
                                    severity="secondary"
                                >
                                    <icon icon="save" />
                                </button>
                                <button
                                    *ngIf="editing"
                                    pButton
                                    pRipple
                                    type="button"
                                    pCancelEditableRow
                                    pButtonIcon="pi pi-times"
                                    (click)="onRowEditCancel(container, ri)"
                                    text
                                    rounded
                                    severity="secondary"
                                >
                                    <icon icon="cancel" />
                                </button>
                            </div>
                        </td>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">No Containers found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
